import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { collection, getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import prodConfig from "./environments/prod"

console.log("NODE_ENV:", process.env.NODE_ENV);
console.log("VUE_APP_DEPLOYMENT_ENV:", process.env.VUE_APP_DEPLOYMENT_ENV);

// deployment script `deploy-kfaw-explore-production.sh` will set APP_DEPLOYMENT_ENV to 'production'
const APP_DEPLOYMENT_ENV = process.env.APP_DEPLOYMENT_ENV || process.env.VUE_APP_DEPLOYMENT_ENV || "development";

  
const USE_PRODUCTION_CONFIG = APP_DEPLOYMENT_ENV === 'production';
console.log(`should use production configs: ${USE_PRODUCTION_CONFIG}, APP_DEPLOYMENT_ENV=${APP_DEPLOYMENT_ENV}`)

const devStagingProjectId = 'riddles-d4fd8';
// the default config is dev/staging (riddles) and used for local development and dev/staging/qa environments
let config = {
  apiKey: 'AIzaSyAAUmEMcgeRwQ72PmmoK2PDUpBK68xo7R0',
  authDomain: `${devStagingProjectId}.firebaseapp.com`,
  databaseURL: `https://${devStagingProjectId}.firebaseio.com`,
  projectId: devStagingProjectId,
  storageBucket: `${devStagingProjectId}.appspot.com`,
  messagingSenderId: '723067634068',
  appId: '1:723067634068:web:a53445c3f694e6df788f81',
};
if (USE_PRODUCTION_CONFIG) {
  config = prodConfig;
  console.info(`using production configs, projectId: ${config.projectId}`)
} else {
  console.info(`using development configs, projectId: ${config.projectId}`)
}

// Initialize Firebase
const app = initializeApp(config);

// Initialize Firebase services
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

// Collection references (Firestore v9+ syntax)
const usersCollection = collection(db, "users");
const huntsCollection = collection(db, "hunts");
const mediaFilesCollection = collection(db, "mediaFiles");
const codeAttemptLogsCollection = collection(db, "codeAttemptLogs");

// Export the services
export {
  auth,
  db,
  huntsCollection,
  storage,
  usersCollection,
  mediaFilesCollection,
  codeAttemptLogsCollection,
};
